import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";
import { GetDepositWalletCore } from "store/api/deposit";
import { LoadingButton } from "@mui/lab";
import QrCode from "components/QrCode";
import http from "config/http";
import { useFormContext } from "react-hook-form";
import useNotify from "hooks/useNotify";

function DepositHiddenQrCode({ selectedWallet }) {
  const notify = useNotify();
  const { watch } = useFormContext();
  const network = watch("network");

  const [showAddress, setShowAddress] = useState(null);
  const [loading, setLoading] = useState(false);

  const getDepositWalletCore = async () => {
    const { coinId, networkId } = selectedWallet;

    try {
      setLoading(true);
      const { data } = await http.get(
        GetDepositWalletCore({ coinId, networkId })
      );

      setShowAddress(data?.data);
    } catch (error) {
      notify(error?.response?.data?.message || "مشکلی پیش آمده است", "error");
    }

    setLoading(false);
  };

  useEffect(() => {
    setShowAddress(null);
  }, [network]);

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {showAddress ? (
        <QrCode
          value={showAddress}
          text={showAddress}
          alertText="آدرس با موفقیت کپی شد"
        />
      ) : (
        <LoadingButton
          color="secondary"
          variant="contained"
          loading={loading}
          onClick={() => getDepositWalletCore()}
        >
          نمایش آدرس ولت
        </LoadingButton>
      )}
    </Box>
  );
}

export default DepositHiddenQrCode;
